<template>
	<div class="b_banxin1">
		<div class="v_box flex">
			<div class="v_boxleft">
				<div class="v_boxlefttop" @click="tohome">
					<img src="@/assets/img/lbico3.png" alt="">通知公告 <span>查看全部</span>
				</div>
				<div class="v_boxleftbtn flex flex_warp">
					<div class="v_boxleftbtnson txtnowarp" @click="topersonalinformation(item)" v-for="(item,index) in newarry" :key="index">
						<img src="@/assets/img/lbico2.png" alt=""> {{item.title}}
					</div>
				</div>
			</div>
			<div class="v_boxright">
				<div class="v_boxlefttop">
					<img src="@/assets/img/remen.png" alt="">热门晒单
				</div>
				<div class="v_boxleftbtn" v-if="remenData.length > 0">
					<router-link :to="{path:'/details', query:{ goods_id:item.goods_id }}" class="v_boxrightson flex" v-for="(item, index) in remenData" :key="index">
						<img :src="http + item.cover" alt="" class="v_boxrightsonleft">
						<div class="v_boxrightsonright">
							<div class="v_boxrightsonrightson1 txtnowarp2">
								{{item.title}}
							</div>
							<div class="v_boxrightsonrightson2 flex">
								<img src="@/assets/img/laba.png" alt="" class="v_boxson2img">
								<div class="v_boxson2txt txtnowarp">
									{{item.content}}
								</div>
							</div>
						</div>
					</router-link>
					
				</div>
				<div class="v_boxleftbtn" v-else>
					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'

	export default {
		name: 'indexnwes',
		data() {
			return {
				newarry: [],
				remenData:[],//热门晒单
				http:'',//域名
			}
		},
		created() {
			let that = this;
			that.http = that.$publicUrl.http1;
			that.getnewall();
			that.getshaidan();
			// if(that.$storage.get('user_data') != null) {
			// 	that.username = that.$storage.get('user_data').alias;
			// 	that.personalData['user_id'] = that.$storage.get('user_data').user_id;
			// 	that.personalFn();
			// } else {
			// 	that.username = '';
			// 	that.personalData = {};
			// }
		},
		methods: {
			//站内信查看全部
			tohome() {
				let that = this;
				that.$router.push({
					path: '/personalinforlist',
					query: {
						id: "1"
					}
				})
			},
			//站内信详情跳转			
			topersonalinformation(index) {
				let that = this;
				that.$router.push({
					path: '/personalinformation',
					query: {
						id: "1",
						bookid: index.id
					}
				})
			},
			getnewall() {
				let that = this;
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.getnewall,
						data: qs.stringify({
							sign: "2",
							page: "1"
						}),
					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.newarry = data.data
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {});
			},
			getshaidan() {
				let that = this;
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.itemremen,
						data: qs.stringify({}),
					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
					
						if(data.stateCode == 10000) {
							that.remenData = data.data
							console.log(that.remenData)
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {});
			}
		}
	}
</script>
<style scoped>
	.b_banxin1 {
		margin-top: 30px;
	}
	
	.v_box {
		width: 100%;
		background-color: #ffffff;
	}
	
	.v_boxleft {
		width: 580px;
		min-height: 325px;
		box-sizing: border-box;
		padding: 0 20px;
	}
	
	.v_boxlefttop {
		width: 100%;
		height: 70px;
		line-height: 30px;
		box-sizing: border-box;
		padding: 20px 0;
		font-size: 16px;
		border-bottom: 2px solid #dc1e33;
		cursor: pointer;
		position: relative;
	}
	
	.v_boxlefttop span {
		position: absolute;
		top: 50%;
		right: 0;
		font-size: 16px;
		line-height: 30px;
		display: inline-block;
		transform: translateY(-50%)
	}
	
	.v_boxlefttop img {
		width: 30px;
		height: 30px;
		display: inline-block;
		object-fit: scale-down;
	}
	
	.v_boxleftbtn {
		width: 100%;
		padding: 20px 0;
		padding-bottom: 0px;
	}
	
	.v_boxleftbtnson {
		width: 270px;
		/* height: 40px; */
		/* line-height: 40px; */
		font-size: 16px;
		cursor: pointer;
		margin-bottom: 32px;
	}
	
	.v_boxleftbtnson img {
		/* height: 40px; */
		width: 25px;
		display: inline-block;
		object-fit: scale-down;
		margin-right: 5px;
	}
	
	.v_boxright {
		width: 600px;
		min-height: 325px;
		padding: 0 20px;
		box-sizing: border-box;
	}
	
	.v_boxrightson {
		width: 100%;
		height: 100%;
		margin-bottom: 20px;
	}
	
	.v_boxrightsonleft {
		width: 100px;
		height: 100px;
		display: block;
		object-fit: scale-down;
	}
	
	.v_boxrightsonright {
		width: calc(100% - 100px);
		box-sizing: border-box;
		padding: 10px 20px;
	}
	
	.v_boxrightsonrightson1 {
		width: 100%;
		height: 60px;
		line-height: 30px;
		font-size: 16px;
	}
	
	.v_boxson2img {
		width: 28px;
		height: 20px;
		display: block;
		object-fit: scale-down;
		margin-right: 5px;
	}
	
	.v_boxson2txt {
		width: calc(100 - 33px);
		line-height: 20px;
		font-size: 16px;
		color: #dc1e33;
	}
</style>